import {loadComponents} from "./functions/helpers";
import ScrollReveal from "scrollreveal";
import {CaseStudies} from "./components/caseStudies";
import {NBIIndexOverTime} from "./components/NBIIndexOverTime";
import {NBIIndexRvU} from "./components/NBIIndexRvU";
import Swiper from 'swiper';
import {pastReportsSwiper} from "./components/pastReportsSwiper";
import {NBIIndexNumber} from "./components/NBIIndexNumber";

import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ProgressPanels} from "./components/ProgressPanels";

gsap.registerPlugin(ScrollTrigger);

//Map of components available in front end and non-gutenberg admin parts
const uiComponents = {
    CaseStudies,
    NBIIndexOverTime,
    NBIIndexRvU
};

(function($){
    // Initialize each block on page load (front end).
    $(document).ready(function(){
        loadComponents(uiComponents);

        //Scroll reveal actions
        $('.progress-block').each(function (){
            let $thisBlock = $(this);
            ScrollTrigger.create({
                trigger: $thisBlock,
                start: "50% bottom", //start when 50% of the element gets above the BOTTOM of the screen
                end: "bottom top", //stop when the BOTTOM part of the element gets above the TOP part of the screen
                onToggle: self => {
                    if (self.isActive) { //when trigger meets the conditions (block is visible on the screen)
                        $thisBlock.removeClass('loading')
                    } else {
                        // $thisBlock.removeClass('show')
                    }
                },
                onUpdate: self => {

                },
                invalidateOnRefresh: true
            });
        })

        // Filters list toggle
        $('.filter-toggle').click(function (e){
            e.stopImmediatePropagation();
            $('.tags', $(this).parent()).toggleClass('active');
            $(this).toggleClass('active');
            $('.site.grid-container').toggleClass('tags-active')
        });
        $('.search-form .tags').click(function (e) {
            // e.stopPropagation();
        })
        //Close tags on mobile
        $('.search-form .tags  .close-tags').click(function (e){
            // e.stopImmediatePropagation();
            $(this).closest('.tags').removeClass('active');
            $('.filter-toggle').removeClass('active');
            $('.site.grid-container').removeClass('tags-active');
        })
        //Hide filters select when clicked outside
        $('.page-case-studies').click(function (){
            $('.search-form .tags').removeClass('active');
            $('.filter-toggle').removeClass('active');
        });
        //close overlay if clicked outside video
        $('.video-overlay').click(function (){
            $('.video-overlay iframe').attr("src", '');
            $(this).removeClass('active');
        });
        //Remove tag from active filters
        $('.close-tag')
            .mousedown(function (){
                $(this).closest('.tag').addClass('down');
            })
            .mouseup(function (){
                $(this).closest('.tag').removeClass('down');
            })
            .mouseout(function (){
                $(this).closest('.tag').removeClass('down');
            })
        ;
        //don't trigger overlay when clicking on edit link
        $('.edit-post').click(function (e){
            e.stopImmediatePropagation();
        })

        $('.youtube-video-embed').each(function (){
            let $thePlayer = $(this);
            let $url = $thePlayer.data('video');
            let $button = $('.play-button', $thePlayer);
            let $iframe = $('iframe', $thePlayer);
            let $cover = $('figure', $thePlayer);
            if (!$url) return;

            $button.click(function (){
                $iframe.attr('src', $url);
                $thePlayer.addClass('playing');
                $cover.fadeOut();
            })
        })
        //Reveal on scroll
        ScrollReveal().reveal('.scrollreveal, h1.entry-title', {
            distance:'35px',
            duration: 650,
            cleanup: true,
            afterReveal: function(el) {
                ScrollReveal().clean(el);
            }
        });

        $('.news-landing .load-more').click(function (){
            // debugger;
            for(let i = 0; i < 9; i++){
                let $thePost = $('.news-landing .all-posts .post.hidden').first();
                let $figure = $('figure', $thePost);
                let $imgURL = $figure.data('src');
                let $title = $figure.data('src');

                $('a', $figure).append('<img src="' + $imgURL + '" alt="'+ $title +'">');
                $thePost.removeClass('hidden');
            }
        });

        $('.submenu-ext > li > a').click(function (e){
            let $nav = $(this).closest('.submenu-ext');
            if (($(window).width() <= 640) && !($nav.hasClass('active'))) {
                e.preventDefault();
            }
            $nav.addClass('active');

        });

        //Mark in css that page is  loaded
        $('body').addClass('page-loaded');

        ProgressPanels();


        //Past reports swiper
        pastReportsSwiper();

        //NBI Index Number
        NBIIndexNumber();

    });
})(jQuery);
